import { render, staticRenderFns } from "./SvgLogo.vue?vue&type=template&id=9f058d24"
var script = {}
import style0 from "./SvgLogo.vue?vue&type=style&index=0&id=9f058d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports